import React, { useEffect, useRef, useState } from "react";
import { ChevronDown, Truck, Sparkles, GraduationCap, Briefcase, LayoutGrid } from "lucide-react";

// Kursusfanerne på forsiden. Linkene vælger fanen via ?spor=.
export const COURSE_TABS = [
  { id: "transport", label: "Transport", desc: "Vognmand, chauffør, taxa og Flextrafik", icon: Truck },
  { id: "it-ai", label: "IT & Kunstig Intelligens", desc: "Digitale kompetencer og AI", icon: Sparkles },
  { id: "dansk", label: "Dansk (FVU)", desc: "Forberedende voksenundervisning", icon: GraduationCap },
  { id: "hakl", label: "HAKL", desc: "Ledelse og drift for vognmænd", icon: Briefcase },
];

const linkCls = "w-full flex items-start gap-3 px-3 py-2.5 rounded-xl text-left transition-colors hover:bg-slate-50";

export const CoursesMenu = ({ active, onGo }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const timer = useRef(null);

  useEffect(() => {
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);

  const enter = () => { clearTimeout(timer.current); setOpen(true); };
  const leave = () => { timer.current = setTimeout(() => setOpen(false), 150); };
  const go = (path) => { setOpen(false); onGo(path); };

  return (
    <div ref={ref} className="relative" onMouseEnter={enter} onMouseLeave={leave}>
      <button onClick={() => setOpen((o) => !o)} aria-expanded={open} aria-haspopup="true" data-testid="nav-courses-menu"
        className={`inline-flex items-center gap-1 px-3 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
          active ? "bg-[hsl(210,100%,50%)]/10 text-[hsl(210,100%,45%)]" : "text-slate-600 hover:text-[hsl(210,100%,45%)] hover:bg-slate-50"}`}>
        Kurser <ChevronDown className={`h-3.5 w-3.5 transition-transform duration-200 ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="absolute left-0 top-full pt-2 z-50" data-testid="nav-courses-dropdown">
          <div className="w-[320px] bg-white rounded-2xl border border-slate-200 shadow-xl p-2">
            {COURSE_TABS.map((t) => (
              <button key={t.id} onClick={() => go(`/?spor=${t.id}`)} className={linkCls} data-testid={`nav-courses-${t.id}`}>
                <t.icon className="h-4 w-4 mt-0.5 text-[hsl(210,100%,45%)] shrink-0" />
                <span>
                  <span className="block text-sm font-semibold text-slate-800">{t.label}</span>
                  <span className="block text-xs text-slate-500">{t.desc}</span>
                </span>
              </button>
            ))}
            <div className="border-t border-slate-100 mt-1 pt-1">
              <button onClick={() => go("/kurser")} className={linkCls} data-testid="nav-courses-all">
                <LayoutGrid className="h-4 w-4 mt-0.5 text-slate-500 shrink-0" />
                <span className="text-sm font-medium text-slate-700">Alle kurser</span>
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// Mobilmenuen: Kurser kan foldes ud med de samme faner.
export const MobileCoursesMenu = ({ onGo }) => {
  const [open, setOpen] = useState(false);
  return (
    <div>
      <button onClick={() => setOpen((o) => !o)} data-testid="nav-courses-menu-mobile"
        className="w-full flex items-center justify-between px-4 py-3 rounded-lg text-sm sm:text-base font-medium text-left text-slate-600 hover:text-[hsl(210,100%,45%)] hover:bg-slate-50">
        Kurser <ChevronDown className={`h-4 w-4 transition-transform duration-200 ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="ml-4 pl-3 border-l border-slate-200 flex flex-col">
          {COURSE_TABS.map((t) => (
            <button key={t.id} onClick={() => onGo(`/?spor=${t.id}`)} data-testid={`nav-courses-mobile-${t.id}`}
              className="flex items-center gap-2 px-3 py-2.5 rounded-lg text-sm text-left text-slate-600 hover:bg-slate-50">
              <t.icon className="h-4 w-4 text-[hsl(210,100%,45%)]" /> {t.label}
            </button>
          ))}
          <button onClick={() => onGo("/kurser")} className="px-3 py-2.5 rounded-lg text-sm text-left text-slate-600 hover:bg-slate-50" data-testid="nav-courses-mobile-all">
            Alle kurser
          </button>
        </div>
      )}
    </div>
  );
};
